<div class="container">
    <div class="inner">
        <div class="info-icon">
            <rr-icon name="info"></rr-icon>
        </div>
        <div class="content-container">
            <div class="gap-8 col">
                <h3>Confirm to proceed</h3>
                <div class="text">The system will collaborate with landing page provider Easy2.
                    To proceed, please conform that you consent to share your data.
                </div>
            </div>
            <div class="row gap-16 justify-center align-center logo-container">
                <img src="images/logo-icon.png">
                <div class="info-icon">
                    <rr-icon name="arrow-right"></rr-icon>
                </div>
                <img src="images/easy2-icon.png">
            </div>
            <div class="info-box">
                <div class="border"></div>
                <div class="info-box-content gap-16 row-gap-16">
                    <rr-icon name="info" ></rr-icon>
                    <div class="info-box-text">
                        <ul>
                            <li>You'll have free access and editing options to the hosted webpage at Easy2 for 14 days.</li>
                            <li><b>No automatic charges</b> after the trial period ends.</li>
                            <li>Only <a (click)="openInfoSharedPopup()">essential information</a> is shared with Easy2.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="click-info">By clicking <b>Connect to Easy2,</b> you agree to <a>Terms & Conditions</a> of Easy2 and acknowledge reading <a>Privacy Policy</a>.</div>
            <div class="button-group">
                <rr-btn type="Primary" tone="Brand" size="small" (btnclick)="createEasy2()">Connect to Easy2</rr-btn>
            </div>
        </div>
    </div>
    <div class="close" (click)="closeDialog()">
        <rr-icon name="close"></rr-icon>
    </div>
</div>